import React from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Fragment, useEffect, useRef, useState } from 'react';
import { BiCheck, BiCaretDown } from 'react-icons/bi';
import Str from '../../../helpers/Str';
import InputSelect from "../../input/InputSelect";
import {Pagination, PaginationNav1Presentation} from "../../table/Pagination";

export interface DropdownItem {
  id?: string;
  label: string;
  onClick?: any;
  status?: string;
}

export interface DropdownProps {
  className?: string;
  trigger?: React.ReactNode;
  items?: DropdownItem[];
  consult?: any;
  onPageChange?: any;
  dataPaginate?: any;
  onClickItem?: any;
  onSelectDropDown?: any;
}

export default function Dropdown({
  className,
  trigger,
  items,
  consult,
  onPageChange,
  dataPaginate,
  onClickItem,
  onSelectDropDown
}: DropdownProps) {
  return (
    <Menu as="div" className={Str.tw(className, 'relative inline-block text-left')}>
      <div>
        <Menu.Button>
          {trigger}
        </Menu.Button>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className={`absolute z-10 right-0 mt-2 ${consult ? 'w-[380px]' : 'w-56'} origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none`}>

            <div className="px-1 py-1">
                {
                    consult ?
                        <>
                            <div className={'px-2 py-2'}>
                                <InputSelect
                                    label={"Status"}
                                    selected={[]}
                                    options={[
                                        {value:'todos', label:'Todos'},
                                        {value:'visualizados', label:'Visualizados'},
                                        {value:'nao_visualizados', label:'Não visualizados'}
                                    ]}
                                    onChangeSelect={(e: any) => onSelectDropDown(e)}
                                    placeholder={"Selecione"}
                                />
                            </div>
                            {
                                items?.map((item, i) => (
                                    <Menu.Item key={i}>
                                        {({ active }) => (
                                            <div className={'flex justify-between mt-1 border border-[#e4edfc] p-3'}>
                                                <div>{item.label}</div>
                                                <div>
                                                    <button
                                                        onClick={event  => {
                                                            event.stopPropagation();
                                                            onClickItem(item)
                                                        }}
                                                        className={`${
                                                            active ? 'bg-primary text-in-primary' : ''
                                                        } group flex w-[100px] h-[30px] border items-center rounded-md px-2 py-2 text-sm`}
                                                    >
                                                        Visualizado
                                                    </button>
                                                </div>

                                            </div>

                                        )}
                                    </Menu.Item>
                                ))
                            }
                            <div className={'px-2 py-2 flex justify-end'}>
                                <PaginationNav1Presentation
                                    onPageChange={onPageChange}
                                    totalPaginas={dataPaginate.total_data}
                                    lastPage={dataPaginate.last_page}
                                />
                            </div>
                        </>
                        :
                        items?.map((item, i) => (
                            <Menu.Item key={i}>
                                {({ active }) => (
                                    <button
                                        onClick={item.onClick}
                                        className={`${
                                            active ? 'bg-primary text-in-primary' : ''
                                        } group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                                    >
                                        {item.label}
                                    </button>
                                )}
                            </Menu.Item>
                        ))
                }
          </div>
            
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
